import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-联盟活动",
  "use": "icon-联盟活动-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" xmlns:xlink=\"http://www.w3.org/1999/xlink\" id=\"icon-联盟活动\"><path d=\"M335.3 484.8L308 191c232.3-149.2 259.6 124.2 450.8-41.9l55.8 281.3c-216.8 139.7-277.9-135.5-479.3 54.4z m-22.7 394.3c-21.7 2-40.8-13.9-42.8-35.6l-60.1-646.8c-2-21.7 13.9-40.8 35.6-42.8 21.7-2 40.8 13.9 42.8 35.6l60.1 646.8c2 21.6-13.9 40.8-35.6 42.8z\" fill=\"\" p-id=\"3589\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol